module.exports = __webpack_public_path__ + "img/no_video.4a378c76.png";